module.exports = __webpack_public_path__ + "img/rocket.f4d2ea9d.png";